// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-1a598951] .el-card__header {\n  font-size: 0.083333rem;\n}\n[data-v-1a598951] .el-card__body {\n  padding-bottom: 0;\n}", "",{"version":3,"sources":["D:/source/2000HuiTian/huitianadmin/<input css 46>"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AAEA;EACE,iBAAiB;AACnB","file":"attchmentEditor.vue","sourcesContent":["/deep/.el-card__header {\n  font-size: 0.083333rem;\n}\n\n/deep/.el-card__body {\n  padding-bottom: 0;\n}"]}]);
// Exports
module.exports = exports;
